// extracted by mini-css-extract-plugin
export default {"center":"_1M-E"};